module.exports = __webpack_public_path__ + "images/embed/shiny_dot.png";